import React from "react";
import { Smartphone, Tablet, Phone } from "lucide-react";
import StatusBadge, { SOFT_TEXT } from "./StatusBadge";
import { formatDateDMY } from "../lib/format";

export const JobCard = ({ job, onClick }) => {
  const notes = (job.notes || "").trim();
  const notesPreview = notes.length > 80 ? notes.slice(0, 80) + "…" : notes;

  const activate = () => onClick?.(job);
  const onKey = (e) => {
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); activate(); }
  };

  const DeviceIcon = /ipad|surfplatta|\btab/i.test(job.device || "") ? Tablet : Smartphone;

  return (
    <div
      data-testid={`job-card-${job.id}`}
      onClick={activate}
      onKeyDown={onKey}
      role="button"
      tabIndex={0}
      aria-label={`Öppna ärende för ${job.customerName}`}
      className="vm-card press-feedback fade-in-up cursor-pointer flex items-start gap-[14px]"
      style={{padding:"16px 18px 16px 14px"}}
    >
      <span className="vm-bubble" style={{marginTop:2}}>
        <DeviceIcon size={20} strokeWidth={1.8} color={SOFT_TEXT[job.status] || "#475569"} aria-hidden="true" />
      </span>
      <div className="flex-1 min-w-0 flex flex-col gap-1">
        <div className="flex items-center justify-between gap-2 min-w-0">
          <h3 data-testid="job-card-customer" className="truncate min-w-0" style={{fontFamily:"inherit",fontSize:16,fontWeight:600,letterSpacing:"-0.2px",color:"#0F172A"}}>{job.customerName}</h3>
          <StatusBadge status={job.status} variant="soft" />
        </div>
        <div className="flex items-center justify-between gap-2 min-w-0">
          <span className="truncate min-w-0 text-[14px] text-[#475569]">{job.device} · {job.technician || "—"}</span>
          <span className="flex-none text-[12px] text-[#64748B]">{formatDateDMY(job.date)}</span>
        </div>
        <div className="flex items-center gap-2 min-w-0 mt-[2px]">
          {job.phone ? (
            <a data-testid="job-card-phone" href={`tel:${job.phone}`}
              onClick={(e) => e.stopPropagation()}
              className="inline-flex flex-none items-center gap-1 text-[13px] font-semibold text-[#2563EB] hover:underline">
              <Phone size={13} aria-hidden="true" />{job.phone}
            </a>
          ) : (
            <span data-testid="job-card-phone-missing" className="flex-none text-[13px] text-slate-400 italic">Telefonnummer saknas</span>
          )}
          <p className="text-[13px] text-[#64748B] truncate flex-1 min-w-0 text-left">{notesPreview || "— inga anteckningar —"}</p>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
